import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { clearToken } from "@/Redux/slice/token";
import { logout } from "@/Redux/slice/userSlice";
import { clearChatState } from "@/Redux/slice/chatSlice";
import { clearPendingSignIn } from "@/utils/twoFactorPending";

const NOTICE_KEY = "alpha-md:disabled-session-notice";
const DEFAULT_MESSAGE = "This account is disabled. Please contact Alpha.MD support.";
let disconnectSessionSocket = null;

export function registerDisabledSessionSocket(disconnect) {
  disconnectSessionSocket = disconnect;
}

export function takeDisabledSessionNotice() {
  try {
    const message = sessionStorage.getItem(NOTICE_KEY);
    sessionStorage.removeItem(NOTICE_KEY);
    return message;
  } catch { return null; }
}

// The rejected request or socket must still belong to the active session.
export function endDisabledSession({ dispatch, getState, token, id, type, message }) {
  if (typeof window === "undefined" || typeof token !== "string" || !token || Cookies.get("token") !== token) return false;
  const state = getState();
  if (state.token?.token && state.token.token !== token) return false;
  const account = state.userData?.userData?.user;
  if (id !== undefined && (!account || String(account._id || account.id) !== String(id) || account.type !== type)) return false;
  const role = account?.type || type || (Cookies.get("isReps") === "true" ? "reps" : "physician");
  const notice = typeof message === "string" && message.trim() ? message : DEFAULT_MESSAGE;

  disconnectSessionSocket?.(token);
  dispatch(clearToken());
  dispatch(logout());
  dispatch(clearChatState());
  Cookies.remove("token");
  Cookies.remove("isReps");
  clearPendingSignIn();
  try { sessionStorage.setItem(NOTICE_KEY, notice); } catch { /* Storage may be unavailable. */ }
  toast.error(notice, { toastId: "account-disabled" });
  // Existing logout uses a reload so account-specific caches are discarded.
  window.location.replace(role === "reps" ? "/reps/login" : "/login");
  return true;
}
